import React, { useState } from "react";
import { UnloadingSvg } from "../../../svgFiles/UnloadingSvg";

import TimeIcon from "../../../images/time.svg";
import CalIcon from "../../../images/cal_icon.svg";
import ExpectedExitDate from "../../../images/exit.svg";
import ExitDate from "../../../images/exitDate.svg";
import ExitTime from "../../../images/exitTime.svg";
import Before from "../../../images/before.svg";
import After from "../../../images/after.svg";
import Status from "../../../images/status.svg";
import KgsIcon from "../../../images/kgs.svg";
import CaseIcon from "../../../images/case.svg";
import DateIcon from "../../../images/calendar.svg";
import RipeningIcon from "../../../images/ripening.svg";
import Evaporated from "../../../images/evaorated.svg";
import "../../../components/shared/modalContent/overview.css";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, getTranslatedRoomName } from "../../../helpers/Utils";
import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from "../../../helpers/constants";

const RipeningOverViewModal = ({ show, setShow, record, mode }) => {

  const [formData, setFormData] = useState(record);
  const { _t } = useTranslator();

  const {
    pallet_code,
    entered_date_time,
    case_entered,
    fruit_entered_in_kg,
    expected_date_to_ripening,
    exit_date_time_to_ripening,
    status,
    room,
    exit_date_time,
    expected_date_to_exit,
    weight_after_ripening,
    weight_before_ripening,
    kg_evaporated
  } = formData;

  const calculated_kg_evaporated = Number(
    (fruit_entered_in_kg - weight_after_ripening).toFixed(2)
  );

  const evaporated_percent = Number(
    (
      ((fruit_entered_in_kg - weight_after_ripening) /
        fruit_entered_in_kg) *
      100
    ).toFixed(2)
  );
  const enetreddate = convertToUserTimezone(entered_date_time,DEFAULT_DATE_FORMAT);
  const time = convertToUserTimezone(entered_date_time,DEFAULT_TIME_FORMAT);
  const exitdate = convertToUserTimezone(exit_date_time_to_ripening,DEFAULT_DATE_FORMAT);
  const exittime = convertToUserTimezone(exit_date_time_to_ripening,DEFAULT_TIME_FORMAT);
  const exitdateRipening = convertToUserTimezone(exit_date_time,DEFAULT_DATE_FORMAT);
  const exittimeRipening = convertToUserTimezone(exit_date_time,DEFAULT_TIME_FORMAT);
  
  const handleClose = () => {
    setShow(false);
  };
  const dateRipening = convertToUserTimezone(expected_date_to_ripening, DEFAULT_DATE_FORMAT);
  const expectedExitDate = convertToUserTimezone(expected_date_to_exit, DEFAULT_DATE_FORMAT);

  
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "cold-storage"
          ? _t("cold_storage_data", "Cold Storage Data")
          : _t("ripening_room_data", "Ripening Room Data")
      }
      headerInfo={true}
      headername={
        mode === "ripening-room" && `${getTranslatedRoomName(room?.name , _t)} ${_t("data", "Data")}`
      }
      BatchCodeInfo={false}
      PalletCode={`(${_t("pallet_code", "Pallet Code")} - ${pallet_code})   `}
    >
      <h4 className="overViewtitle">
        {UnloadingSvg}
        {_t("data", "Data")}
      </h4>
      <ul className="overviewGrid processing mb-4">
        <li className="overviewGrid_card">
          {" "}
          <img src={DateIcon} alt="" />
          {_t("entered_date", "Entered Date")} : <span>{enetreddate}</span>
        </li>

        {/* In ripening room i dont need this  */}
        {mode !== "ripening-room" && (
          <li className="overviewGrid_card">
            {" "}
            <img src={TimeIcon} alt="" />
            {_t("entered_time", "Entered Time")} : <span>{time}</span>
          </li>
        )}

        {mode !== "ripening-room" && (
          <li className="overviewGrid_card">
            {" "}
            <img src={KgsIcon} alt="" />
            {_t("kg_entered", "Kg Entered")} : <span>{fruit_entered_in_kg}</span>
          </li>
        )}
        <li className="overviewGrid_card">
          {" "}
          <img src={CaseIcon} alt="" />
          {_t("cases", "Cases")} : <span>{case_entered}</span>
        </li>
        {/* <li className="overviewGrid_card">
          {" "}
          <img src={CalIcon} alt="" />
          {_t("expected_date_ripening", "Expected Date of Ripening")}: <span>{dateRipening}</span>
        </li> */}
        {mode === "cold-storage" && (
          <>
            <li className="overviewGrid_card">
              {" "}
              <img src={ExitDate} alt="" />
              {_t("exit_date", "Exit Date")} : <span>{exitdate}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={ExitTime} alt="" />
              {_t("exit_time", "Exit Time")} : <span>{exittime}</span>
            </li>
          </>
        )}
        {mode === "ripening-room" && (
          <>
            <li className="overviewGrid_card">
              {" "}
              <img src={ExpectedExitDate} alt="" />
              {_t("expected_date_exit", "Expected Date of Exit")} :{" "}
              <span>{expectedExitDate}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={ExitDate} alt="" />
              {_t("exit_date", "Exit Date")} : <span>{exitdateRipening} {exittimeRipening}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={Before} alt="" />
              {_t("weight_before_ripening", "Weight Before Ripening")} :{" "}
              <span>{fruit_entered_in_kg}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={After} alt="" />
              {_t("weight_after_ripening", "Weight After Ripening")} :{" "}
              <span>{weight_after_ripening}</span>
            </li>
            <li className="overviewGrid_card">
              {" "}
              <img src={Evaporated} alt="" />
              {_t("kg_evaporated", "KG Evaporated")} :{" "}
              <span>{evaporated_percent}%</span>
            </li>
            
            {/* <li className="overviewGrid_card">
              {" "}
              <img src={ExitTime} alt="" />
              {_t("exit_time", "Exit Time")} : <span>{exittimeRipening}</span>
            </li> */}
          </>
        )}
        <li className="overviewGrid_card">
          {" "}
          <img src={Status} alt="" />
          {_t("status", "Status")} :{" "}
          <span>
            {status === "ripening"
              ? _t("ripening", "Ripening")
              : _t("moved", "Moved")}
          </span>
        </li>
      </ul>
    </CommonModal>
  );
};

export default RipeningOverViewModal;